import React, { useState } from 'react'

import { Grid, SvgIconProps, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

import modals from 'constants/modals'
import { useModal } from 'utils/providers/ModalProvider'
import { QuestionMarkIcon } from 'assets/icons'
import { SupportDrawer } from 'components/SupportDrawer'
import { useIsMobile } from 'utils/hooks/useIsMobile'

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      position: 'static',
    },
  },
  text: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '18px',
  },
  container: {
    cursor: 'pointer',
  },
}))

const Support = ({
  iconProps = { opacity: 0.3 },
  title = 'Support',
}: {
  iconProps?: SvgIconProps
  title?: string
}) => {
  const classes = useStyles()
  const { showModal } = useModal()
  const [drawerOpened, setDrawerOpened] = useState(false)

  const isMobile = useIsMobile()

  const onSupportClick = () => {
    if (isMobile) {
      return setDrawerOpened(true)
    }
    showModal(modals.supportModal)
  }

  return (
    <Grid className={classes.root}>
      <Grid container onClick={onSupportClick} className={classes.container}>
        <QuestionMarkIcon
          sx={{ width: 16, height: 16, mr: 1 }}
          {...iconProps}
        />
        {title ? (
          <Grid>
            <Typography className={classes.text}>{title}</Typography>
          </Grid>
        ) : null}
      </Grid>
      <SupportDrawer open={drawerOpened} setOpen={setDrawerOpened} />
    </Grid>
  )
}

export default Support
